import { GetObjectHelperBase } from './GetObjectHelperBase';
export class GetPropertyObjectHelper extends GetObjectHelperBase {
    constructor() {
        super(...arguments);
        this.index = 0;
    }
}

//# sourceMappingURL=GetPropertyObjectHelper.js.map
